import React, { useCallback, useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
const carouselImages = ['https://cdn.magicpatterns.com/uploads/iuqCikMWjHJyidDZ9w1xUu/test2.webp', 'https://cdn.magicpatterns.com/uploads/1LBZjEPAqF6Lr1GeZXCxCy/test3.webp', 'https://cdn.magicpatterns.com/uploads/oQ2M77cKFejM38JkicNtop/test4.webp', 'https://cdn.magicpatterns.com/uploads/7pggpnBU4vjWjguCn9wiWX/test5.webp', 'https://cdn.magicpatterns.com/uploads/dncH9DRXSXUTqdpqGPTrYU/test6.webp'];
export function SocialProof() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const nextSlide = useCallback(() => {
    setCurrentIndex(prevIndex => prevIndex === carouselImages.length - 1 ? 0 : prevIndex + 1);
  }, []);
  const prevSlide = useCallback(() => {
    setCurrentIndex(prevIndex => prevIndex === 0 ? carouselImages.length - 1 : prevIndex - 1);
  }, []);
  useEffect(() => {
    const timer = setInterval(() => {
      nextSlide();
    }, 5000);
    return () => clearInterval(timer);
  }, [nextSlide, currentIndex]); // Added currentIndex to reset timer on manual change
  return <section className="py-5 px-4 bg-brand-creamAlt" data-id="element-193">
      <div className="max-w-7xl mx-auto" data-id="element-194">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10" data-id="element-195">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-brand-brown mb-4" data-id="element-196">
            LO QUE DICEN NUESTROS CLIENTES
          </h2>
          <div className="w-24 h-1 bg-brand-gold mx-auto rounded-full" data-id="element-197"></div>
        </motion.div>

        <div className="relative max-w-sm mx-auto" data-id="element-198">
          {/* Carousel Container */}
          <div className="relative aspect-[9/16] w-full rounded-2xl overflow-hidden shadow-xl bg-white flex items-center justify-center" data-id="element-199">
            <AnimatePresence data-id="element-200">
              <motion.img key={currentIndex} src={carouselImages[currentIndex]} alt={`Testimonio ${currentIndex + 1}`} initial={{
              opacity: 0
            }} animate={{
              opacity: 1
            }} exit={{
              opacity: 0
            }} transition={{
              duration: 0.5
            }} className="absolute inset-0 w-full h-full object-contain" data-id="element-201" />
            </AnimatePresence>
          </div>

          {/* Navigation Arrows */}
          <button onClick={prevSlide} className="absolute top-1/2 -left-4 md:-left-12 -translate-y-1/2 w-10 h-10 bg-white rounded-full shadow-lg flex items-center justify-center text-brand-brown hover:scale-110 transition-transform z-10" aria-label="Testimonio anterior" data-id="element-202">
            <ChevronLeftIcon className="w-6 h-6" data-id="element-203" />
          </button>

          <button onClick={nextSlide} className="absolute top-1/2 -right-4 md:-right-12 -translate-y-1/2 w-10 h-10 bg-white rounded-full shadow-lg flex items-center justify-center text-brand-brown hover:scale-110 transition-transform z-10" aria-label="Siguiente testimonio" data-id="element-204">
            <ChevronRightIcon className="w-6 h-6" data-id="element-205" />
          </button>

          {/* Dot Indicators */}
          <div className="flex justify-center gap-2 mt-6" data-id="element-206">
            {carouselImages.map((_, idx) => <button key={idx} onClick={() => setCurrentIndex(idx)} className={`w-2.5 h-2.5 rounded-full transition-colors ${idx === currentIndex ? 'bg-brand-terracotta' : 'bg-brand-brown/20'}`} aria-label={`Ir al testimonio ${idx + 1}`} data-id="element-207" />)}
          </div>
        </div>
      </div>
    </section>;
}